import { API_PORT, FRONTEND_PORT } from "./constants";

// DO NOT PUT SECRETS IN HERE!!!
const development = {
  app: {
    HOST:
      import.meta.env.VITE_APP_FRONTEND_HOST ||
      `http://localhost:${FRONTEND_PORT}`,
  },
  api: {
    HOST: import.meta.env.VITE_APP_API_HOST || `http://localhost:${API_PORT}`,
  },
  tracking: {
    DEBUG: true,
    ENABLED: false,
    GOOGLE_ID: "G-JQN958QXJF",
    MIXPANEL_VERBOSE_LOG: true,
    MIXPANEL_ID: "d34b18861b5c0ad5ffe89d8d307bdcdc",
    STATSIG_KEY: "client-ntzxY8eFoeabjvRLm0AvTF1uFPkb9X7Qu8w1EmeRKH1",
  },
};

export type Config = typeof development;
export default development;
